import { StoryblokComponent } from '@storyblok/react';

import { getServiceOSLink } from 'apps/urban/utils/getServiceOSLink/getServiceOSLink';
import { getURLFromStoryblokLink } from 'apps/urban/utils/getURLFromStoryblokLink/getURLFromStoryblokLink';
import Link from 'next/link';

import { getBorderStyleFromStory } from '../../utils/getBorderStyleFromStory';
import { getColorFromStory } from '../../utils/getColorFromStory';
import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';
import { CTAWrapper } from './CTA.style';
import { CTAProps } from './CTA.types';

export const CTA = (props: CTAProps) => {
  const {
    text,
    variant,
    link,
    width,
    widthMobile,
    richText,

    backgroundColor,
    textColor,
    borderStyle,
    borderColor,
    borderWidth,

    hoverBackgroundColor,
    hoverTextColor,
    hoverBorderStyle,
    hoverBorderColor,
    hoverBorderWidth,
  } = props?.blok || {};

  const linkHref = getURLFromStoryblokLink(link);

  const { isServiceOS, href: finalHref } = getServiceOSLink(linkHref);

  const renderContent = () => {
    return (
      <CTAWrapper
        {...(isServiceOS ? { as: 'a', href: finalHref } : {})}
        disabled={props?.disabled}
        type={props?.type}
        variant={variant}
        width={width}
        widthMobile={widthMobile}
        className={props?.className}
        backgroundColor={getColorFromStory(backgroundColor)}
        textColor={getColorFromStory(textColor)}
        borderStyle={getBorderStyleFromStory(borderStyle)}
        borderColor={getColorFromStory(borderColor)}
        borderWidth={borderWidth}
        hoverBackgroundColor={getColorFromStory(hoverBackgroundColor)}
        hoverTextColor={getColorFromStory(hoverTextColor)}
        hoverBorderStyle={getBorderStyleFromStory(hoverBorderStyle)}
        hoverBorderColor={getColorFromStory(hoverBorderColor)}
        hoverBorderWidth={hoverBorderWidth}
        onClick={props?.onClick}
        {...patchedStoryblokEditable(props?.blok)}
      >
        {richText?.length ? <StoryblokComponent blok={richText[0]} /> : text}
      </CTAWrapper>
    );
  };

  if (isServiceOS) return renderContent();

  return (
    <Link href={linkHref ?? ''} passHref>
      {renderContent()}
    </Link>
  );
};
